<template>
  <Wrapper>
    <div class="mb-10 text-left">
      <h3 class="text-gray-600 text-lg font-bold">
        Registro uno a uno de entidades vigiladas
      </h3>
      <p class="text-gray-400 font-bold">
        Ingrese la información del usuario que registrará de manera individual
      </p>
    </div>
    <a-form-model
      layout="vertical"
      :model="form"
      class="max-w-md mx-auto flex flex-col"
    >
      <a-form-model-item label="Nombre abreviado de la entidad">
        <a-input v-model="form.name" placeholder="Ej: Banco de la républica" />
      </a-form-model-item>
      <a-form-model-item label="NIT">
        <a-input
          v-model="form.nit"
          placeholder="Ej: 000-000000000"
          :disabled="true"
        />
      </a-form-model-item>
      <a-form-model-item label="Código de la entidad">
        <a-input
          v-model="form.sfc_code"
          placeholder="número"
          :disabled="true"
        />
      </a-form-model-item>

      <a-form-model-item label="Tipo de entidad" prop="region">
        <a-select v-model="form.company_type" placeholder="Seleccione el tipo">
          <a-select-option
            v-for="company in formOptions.optionsCompanyType"
            :value="company.code"
            :key="company.code"
          >
            {{ company.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="Indique si la entidad vigilada participa en el procedimiento Agiliza."
      >
        <BaseRadio
          ref="sensitiveData"
          name="sensitiveData"
          id="sensitiveData"
          :radioOptions="optionsYN"
          v-model="isAgiliza"
          :required="true"
        />
      </a-form-model-item>
      <template v-if="allReasonAgiliza.length > 0">
        <a-form-model-item
          v-if="isAgiliza === 1"
          label="Selección de los motivos de Agiliza gestionados por la entidad."
        >
          <BaseMultiSelect
            :valuesSelected="fileTypeSelection"
            :defaultValues="fileTypeSelected"
            :data="allReasonAgiliza"
            label="name"
            @notify-objects="setMultiSelect($event)"
          />
        </a-form-model-item>
      </template>
      <a-form-model-item
        v-if="isAgiliza === 1"
        label="Selección de dia(s) de disponibilidad de la entidad para la gestión de quejas Agiliza."
      >
        <BaseMultiSelect
          :valuesSelected="void_array_available_day"
          :defaultValues="availableDaySelected"
          :data="customoAvailableDay"
          label="name"
          @notify-objects="setMultiSelectAvailableDay($event)"
        />
      </a-form-model-item>
      <div v-if="feedback">
        <p class="my-2 text-xs text-center text-red-500">{{ feedback }}</p>
      </div>
      <div class="mt-4 flex flex-col md:flex-row gap-5">
        <a-button
          type="danger"
          @click="$router.go(-1)"
          shape="round"
          ghost
          :block="true"
          :loading="loading"
        >
          <span class="mx-2">CANCELAR</span>
        </a-button>
        <a-button
          type="primary"
          @click="updateCompany"
          shape="round"
          :block="true"
          :loading="loading"
        >
          <span class="mx-2">GUARDAR</span>
        </a-button>
      </div>
    </a-form-model>
  </Wrapper>
</template>

<script>
import Wrapper from "../../UI/Wrapper";
export default {
  components: { Wrapper },
  data() {
    return {
      value: 1,
      authorizationFiles: [],
      companyFile: null,
      feedback: "",
      loading: false,
      form: {
        name: "",
        nit: "",
        sfc_code: "",
        company_type: "",
      },
      allReasonAgiliza: [],
      isAgiliza: 2,
      optionsYN: [
        { id: 1, name: "Sí" },
        { id: 2, name: "No" },
      ],
      fileTypeSelected: [],
      fileTypeSelection: [],
      availableDaySelected: [],
      void_array_available_day: [],
    };
  },
  async created() {
    let options = await this.$store.dispatch("form/loadReasonsAgilizaOptions");

    this.allReasonAgiliza = options.map((item) => {
      return {
        id: item.id,
        name: item.name,
      };
    });

    const { id } = this.$route.query;
    if (id) {
      await this.getCompany(id);
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    async getCompany(id) {
      this.loading = true;
      let { error, data } = await this.$api.getCompany(id);
      this.loading = false;

      if (error)
        this.showToast("error", "Error consultando los datos de la entidad");

      if (data) {
        this.form = { ...data };
      }

      this.isAgiliza = this.form.is_agiliza === true ? 1 : 2;
      if (this.form.is_agiliza) {
        if (this.form.agiliza_reasons) {
          this.fileTypeSelection = this.allReasonAgiliza.map((item) => item.id);
          this.fileTypeSelected = this.allReasonAgiliza
            .filter((item) => this.form.agiliza_reasons.includes(item.id))
            .map((item) => item.id);
        }
        if (this.form.days_available) {
          this.void_array_available_day = this.customoAvailableDay.map(
            (item) => item.id,
          );
          this.availableDaySelected = this.customoAvailableDay
            .filter((item) => this.form.days_available.includes(item.id))
            .map((item) => item.id);
        }
      }
    },
    async updateCompany() {
      if (!this.checkForm()) {
        return;
      }

      let isAgilizaBool = this.isAgiliza === 1 ? true : false;
      this.form.is_agiliza = isAgilizaBool;

      if (isAgilizaBool) {
        // Aseguramos que no se envíen duplicados al guardar
        this.form.agiliza_reasons = [...new Set(this.fileTypeSelected)];
        this.form.days_available = [...new Set(this.availableDaySelected)];
      } else {
        this.form.agiliza_reasons = [];
        this.form.days_available = [];
      }

      const myForm = { ...this.form };
      this.loading = true;
      let { error, data } = await this.$api.updateCompany(myForm, this.form.id);
      this.loading = false;

      if (error) this.showToast("error", "Error editando la entidad.");

      if (data) {
        if (data.code === 200) {
          this.showToast("success", "Entidad actualizada correctamente.");
          this.$router.go(-1);
        } else if (data.code === 401) {
          // NIT
          this.showToast("error", data.error);
        } else if (data.code === 402) {
          // Código y tipo de entidad
          this.showToast("error", data.error);
        }
      }
    },
    checkForm() {
      this.feedback = null;

      if (this.$validator.isEmpty(this.form.name)) {
        this.feedback = "Introduzca el nombre de la entidad.";
        return false;
      }
      if (this.$validator.isEmpty(this.form.company_type + "")) {
        this.feedback = "Seleccione el tipo de la entidad.";
        return false;
      }
      if (this.isAgiliza === 1 && this.fileTypeSelected.length === 0) {
        this.feedback = "Debe seleccionar por lo menos un motivo agiliza";
        return false;
      }
      if (this.isAgiliza === 1 && this.availableDaySelected.length === 0) {
        this.feedback =
          "Debe seleccionar por lo menos un día para establecer la disponibilidad";
        return false;
      }
      return true;
    },
    setMultiSelect(ev) {
      this.fileTypeSelected = ev.map((item) => item.id);
    },
    setMultiSelectAvailableDay(ev) {
      this.availableDaySelected = ev.map((item) => item.id);
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
    customoAvailableDay: function () {
      return this.$store.state.form?.optionsAvailableDay.sort(
        (a, b) => a.id - b.id,
      );
    },
  },
};
</script>
